import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { CreateLocation } from '../mutations/createLocation.mutation';
import type { CreateLocationMutation, CreateLocationMutationVariables } from '../types';

export const useCreateLocationMutation = (
  options?: MutationOptions<CreateLocationMutation, CreateLocationMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateLocation), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('organization'),
      });
    },
  });
};
